export default "__VITE_ASSET__BsktGfGC__"